<template>
	<div>
		  <Breadcrumbs main="Raw Materials" title="Add Material" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Material Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="product_name_eng"/>
											</div>
										</div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Stock<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="" v-model="product_stock"/>
													
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Material Image<span class="text-danger">*</span></label>
												<input class="form-control" type="file" placeholder=""/>
												
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

				button_title: "Save",

				product_name_eng: "",
				product_name_hindi: "",
				product_gst: "",
				product_stock: "",
				product_price: "",
				gst: 1,

				// delete: false,
				// active_page_url: null,
			};
		},
		created() {
			// this.addRow();

		},
		
		methods: {

			// addRow() {
			// 	this.inputs.push({
			// 		name: "",
			// 		phone: "",
			// 		email: ""
			// 	});
			// },

			// deleteRow(index) {
			// 	this.inputs.splice(index, 1);
			// },

			addRow() {
              	this.inputs.push({ value: null });
			},

			deleteRow(index) {
				this.inputs.splice(index, 1);
				this.campaign_images.splice(index, 1);
			}, 

			campaign_setFile(e, index) {
				this.campaign_images.push(e.target.files[0]);
				this.inputs[index].image = e.target.files[0];
				this.inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
			},
				
			clearForm() {
				this.edit = false;
				this.errors = {};
			},

		},
	};

</script>